module.exports = __webpack_public_path__ + "media/images/weather/315_night-77002152e0c5462cc65c2accfa8eca00.png";